import { render } from "./ModalAddTransporterGroups.vue?vue&type=template&id=6a4ecd32&scoped=true"
import script from "./ModalAddTransporterGroups.vue?vue&type=script&lang=js"
export * from "./ModalAddTransporterGroups.vue?vue&type=script&lang=js"

import "./ModalAddTransporterGroups.vue?vue&type=style&index=0&id=6a4ecd32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4ecd32"]])

export default __exports__